// CSV input file fields to create asset.
export const productCSVFileFields = {
	description: 'Description (Product Parents)',
	upc: 'UPC (Product Children)',
	itemNumber: 'Item Number (Product Parents)',
	vendorNumber: 'Vendor Number (Product Children)',
	modelNumber: 'Model Number (Product Children)',
	projectIVM: 'ProjectIVM',
	outboundDesignation: 'Outbound Designation',
	loweUrl: 'Lowes URL (Product Children)',
	catId: 'Cat ID (Product Parents)',
	barcodeValue: 'Barcode Value',
};
export const assetPlatforms = {
	lowes: 'Lowes.com',
};

export const assetEsSearchFields = [
	'id',
	'name',
	'barcode',
	'jiraTask',
	'product.id',
	'product.itemNumber',
	'product.modelId',
	'product.vendorNumber',
	'product.omniItemId',
	'product.barcode',
	'product.description',
	'alignment',
	'tags',
	'artifacts.status',
	'artifact.resolution',
	'sourceFiles.id',
	'sourceFiles.filename',
];
